import { render, staticRenderFns } from "./LobbyComponent.vue?vue&type=template&id=5842fba6&"
import script from "./LobbyComponent.vue?vue&type=script&lang=ts&"
export * from "./LobbyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LobbyComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports